import { SET_RATES } from '../actions/rates';

export type IRates = Record<string, any | number>;

export interface IRatesReducer {
  items: IRates
  loading: boolean
}

const defaultState = {
  items: {},
  loading: true,
};

const ratesReducer = (state: IRatesReducer = defaultState, action: any) => {
  switch (action.type) {
  case SET_RATES:
    return state = {
      items: action.payload,
      loading: false
    };
  default:
    return state;
  }
};

export default ratesReducer;